import { makeAutoObservable } from "mobx";
import { Subject } from "rxjs";
import {
  IAPIPaginationResponse,
  PaginationModel,
} from "@mindmemobile/mm-shared-global";
import { PaymentGridModel } from "../models/PaymentGridModel";
import { PaymentDetailPageModel } from "../models/PaymentModels";
import { IAPIPaymentGridModel } from "../interfaces/IAPIPaymentModels";

export default class PaymentStore {
  public gridData: PaymentGridModel[] = [];
  public pagination: PaginationModel = new PaginationModel();
  public searchSubject = new Subject<boolean>();
  public searchValue: string = "";
  showFilter: boolean = false;
  public detailPage: PaymentDetailPageModel | null = null;
  constructor() {
    makeAutoObservable(this);
  }

  toggleFilter(): void {
    this.showFilter = !this.showFilter;
  }
  updateDetailPage(data: PaymentDetailPageModel): void {
    this.detailPage = new PaymentDetailPageModel(data);
  }

  updateSearchValue(value: string): void {
    this.searchValue = value;
    this.pagination = new PaginationModel({ pageNumber: 1, pageSize: 10 });
  }

  deserializeGridData(
    data: IAPIPaymentGridModel[],
    pagination: IAPIPaginationResponse,
    excludePaginationChange: boolean = false
  ): void {
    const mappedData = data.map((item) =>
      PaymentGridModel.deserializeAPIModel(item)
    );
    if (!excludePaginationChange) {
      this.pagination = PaginationModel.deserialize(pagination);
    }
    this.gridData = mappedData;
  }

  updatePagination(data: PaginationModel): void {
    this.pagination = new PaginationModel(data);
  }
}
